import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { terminateTokens } from "../../api/utils/localStorage";
import { logout } from "../shared/slices/authSlice";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { Routes } from "../../routes-config";

const MsalLogout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(logout());
    terminateTokens();
    navigate(Routes.STAFF_LOGIN);
  }, []);
  return <div />;
};
export default MsalLogout;
